<template lang="pug">
  crud-form( v-bind="formPropsApv" @submitForm="submitForm" @reset="reset")
</template>

<script>
import { CrudForm } from '@/components/reusable_components'
import { EmployeeIpsFields } from './fields'
import ProviredIpsService from '@/services/api/hrProviredIps'
import EmployeeService from '@/services/api/employee'

/* vuex */
import { mapState, mapActions } from 'vuex'
export default {
    name: 'employee-isp',
    // props: {},
    data: function() {
        return {
            ipsFields: EmployeeIpsFields,
        }
    },
    computed: {
        /*
         */
        ...mapState('EmployeeModule', {
            employee: 'employee',
        }),
        formPropsApv() {
            return {
                editable: this.$can('EDIT_EMPLOYEE'),
                readOnly: !this.$can('EDIT_EMPLOYEE'),
                class: 'elevation-0',
                fields: this.ipsFields,
                submitText: 'Guardar',
                //noButtons: true,
                ref: 'formIps',
            }
        },
    },
    methods: {
        // -- UI Modification
        // -- Data fetching
        // -- Data handling and transformations
        // -- Validations and Error handling
        // -- Other functions
        setIpsOptionData: function(index, value) {
            this.ipsFields[index].options.data = value
        },
        initEmployeeInfo() {
            this.$nextTick(() => {
                this.$refs.formIps.vmodels.hr_previred_ips_id = this.employee.hr_employee_ips.hr_previred_ips_id
                this.$refs.formIps.vmodels.quotation_rate = this.employee.hr_employee_ips.quotation_rate
            })
        },
        async submitForm(event) {
            let employeeSub = { ...event }
            employeeSub.hr_employee_id = this.employee.id

            let resp = await EmployeeService.updateIps(employeeSub)
            this.resetSnackbarState()

            if (resp.status === 'success') {
                let payload = this.fillSnack(
                    'success',
                    'IPS',
                    'Datos guardados exitosamente'
                )
                this.initSnackbar(payload)
                this.$refs.formIps.editSwitch = false
            } else {
                let payload = this.fillSnack('error', 'Error', response)
                this.initSnackbar(payload)
            }
        },
        /*
         */
        reset() {
            this.initEmployeeInfo()
        },
        // -- Vuex mappings
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
    },
    watch: {
        employee(val) {
            this.initEmployeeInfo()
        },
    },
    components: {
        'crud-form': CrudForm,
    },
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods
    beforeMount: async function() {
        this.setIpsOptionData(0, await ProviredIpsService.fetchAll())
        //this.initEmployeeInfo()
    },
    mounted: function() {
        //this.initEmployeeInfo()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_EMPLOYEE')) ctx.$router.push('/')
        })
    },
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
</style>